import { render, staticRenderFns } from "./HaiBoTangOrder.vue?vue&type=template&id=59f09d4e&scoped=true"
import script from "./HaiBoTangOrder.vue?vue&type=script&lang=js"
export * from "./HaiBoTangOrder.vue?vue&type=script&lang=js"
import style0 from "./HaiBoTangOrder.vue?vue&type=style&index=0&id=59f09d4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f09d4e",
  null
  
)

export default component.exports